import { v4 } from 'uuid';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';

export const makeEntityId = (prefix: EntityIdPrefix): string => `${prefix}-${getNormalizeEntityId()}`;

export const getNormalizeEntityId = (): string => v4().replaceAll('-', '');
